<template>
  <div>
    <LoadingSpinner />
    <div class="min-h-screen flex flex-col overflow-hidden">
      <!-- Main content -->
      <div class="flex flex-grow min-w-0 bg-transparent">
        <SideBar>
          <div class="shadow mb-3 rounded-lg bg-gray-200">
            <button
              style="display:none;"
              class="w-full pt-2 pb-2 font-semibold bg-gray-200 hover:text-white hover:bg-gray-400 rounded-t-lg"
              @click="openModal('generateReport')"
            >
              Generate Report
            </button>
            <ModalComponent
              :show="modals.generateReport"
              @update:show="updateModal('generateReport', $event)"
            >
              <p>The Generate Report feature is still under development.</p>
            </ModalComponent>
            <button
              style="display:none;"
              class="w-full pt-2 pb-2 font-semibold bg-gray-200 hover:text-white hover:bg-gray-400"
              @click="viewLastReport"
            >
              View Last Report
            </button>
            <ModalComponent
              :show="modals.viewLastReport"
              @update:show="updateModal('viewLastReport', $event)"
            >
              <p>This View Last Report feature is still under development.</p>
            </ModalComponent>
            <button
              class="w-full py-2 rounded-lg font-semibold bg-transparent hover:text-white hover:bg-gray-400"
              @click="sendReportByEmail"
            >
              Send Report
            </button>
            <button
              style="display:none;"
              class="w-full pt-2 pb-2 font-semibold bg-gray-200 hover:text-white hover:bg-gray-400 rounded-b-lg"
              @click="openModal('preferences')"
            >
              Preferences
            </button>
            <ModalComponent
              :show="modals.preferences"
              @update:show="updateModal('preferences', $event)"
            >
              <p>The Preferences feature is still under development.</p>
            </ModalComponent>
          </div>
          <ContactInformation />
        </SideBar>

        <!-- Data display area -->
        <main class="flex-1 min-w-0 overflow-x-auto px-4 py-2 bg-[url('../assets/work_area_background2.png')]">
          <CompanySelector />
          <ScrollableDataContainer />
          <hr class="border-t m-2 border-gray-400 shadow">
          <div class="flex justify-center">
            <ChartDisplay :key="renderKey" />
            <span class="sr-only">Chart key: {{ renderKey }}</span>
            <div class="pt-8">
              <CalendarSelector />
            </div>
          </div>  
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import CompanySelector from './CompanySelector.vue'
import ContactInformation from './ContactInformation.vue'
import ScrollableDataContainer from './ScrollableDataContainer.vue';
import ChartDisplay from './ChartDisplay.vue';
import CalendarSelector from './CalendarSelector.vue';
import ModalComponent from './ModalComponent.vue';
//import ConfirmationDialogue from './ConfirmationDialogue.vue';
import LoadingSpinner from './LoadingSpinner.vue'; // Import LoadingSpinner
import { defineComponent, computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '../pinia/authStore';
import { useDsaReportsStore } from '../pinia/dsaReportsStore';
import SideBar from '@/ReusableComponents/SideBar.vue';

export default defineComponent({
  name: 'LandingPage',
  components: {
    CompanySelector,
    ScrollableDataContainer,
    ChartDisplay,
    CalendarSelector,
    ModalComponent,
    //ConfirmationDialogue,
    ContactInformation,
    LoadingSpinner,
    SideBar,
  },
  setup() {
    const route = useRoute();
    const renderKey = ref(0);
    const authStore = useAuthStore();
    const performLogin = async () => {
      try {
        authStore.login();
      } catch (error) {
        console.error('Login failed:', error);
      }
    };

    const performLogout = () => {
      authStore.logout();
    };

    watch(
      () => route.fullPath,
      (nextPath, prevPath) => {
        renderKey.value += 1;
        console.debug('[DSAReportLandingPage] route change', { prevPath, nextPath, renderKey: renderKey.value });
      }
    );

    const isAuthenticated = computed(() => authStore.isAuthenticated); 
    return {
      isAuthenticated,
      authStore,
      performLogin,
      performLogout,
      renderKey,
    };
  },
  data() {
    return {
      modals: {
        generateReport: false,
        viewLastReport: false,
        preferences: false,
        logout: false,
      },
      showModal: true,
    };
  },
  computed: {
    myStore() {
      return useDsaReportsStore();
    },
    formattedStartDate() {
      return this.myStore.formattedStartDate;
    },
    formattedEndDate() {
      return this.myStore.formattedEndDate;
    },
    selectedFrequencyLabel() {
      return this.myStore.selectedFrequencyLabel;
    },
    selectedCompanyLabel() {
      return this.myStore.selectedContractName;
    },
    lastReportAvailable() {
      return this.myStore.lastReport.company && this.myStore.lastReport.frequency && this.myStore.lastReport.startDate && this.myStore.lastReport.endDate;
    }
  },
  mounted() {
    const authStore = useAuthStore();
    const myStore = useDsaReportsStore();
    authStore.checkAuthStatus();
    myStore.fetchUserData();
  },
  methods: {
    openModal(type) {
      this.modals[type] = true;
    },
    updateModal(type, value) {
      this.modals[type] = value;
    },
    openLogoutDialog() {
      this.modals.logout = true;
    },
    sendReportByEmail() {
      const myStore = useDsaReportsStore();
      const email = 'Client Email';
      const subject = encodeURIComponent('DSA Report Update for ' + myStore.formattedStartDate + " to " + myStore.formattedStartDate);
      const body = encodeURIComponent('Attached you will find the requested DSA Report.');
      const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
      window.open(mailtoLink, '_blank');
    },
    viewLastReport() {
      const myStore = useDsaReportsStore();
      myStore.setCurrentToLastReport();
    }
  }
});
</script>
